"use client";
import { useEffect, useState } from "react";
import { useTransitionState } from "next-transition-router";

// Defer mounting heavy subtrees — standalone <Canvas> R3F roots — until the
// route transition has settled. Creating an R3F root while a transition is
// mid-commit can double-commit and trip React error #177 ("Cannot commit the
// same tree as before"); it also janks the 400ms page animation with WebGL
// context setup. Once settled it stays true for the life of the component.
export function useAfterTransition() {
  const { stage } = useTransitionState();
  const [settled, setSettled] = useState(stage === "none");
  useEffect(() => {
    if (stage === "none") setSettled(true);
  }, [stage]);
  return settled;
}
